import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormHelper } from '../../helpers/form.helper';

@Component({
  selector: 'shared-form-field-container',
  templateUrl: './form-field-container.component.html',
  styleUrls: ['./form-field-container.component.scss'],
  standalone: false,
})
export class FormFieldContainerComponent {
  @Input() label: string;
  @Input() control: AbstractControl;
  @Input() containerClass: string;
  @Input() contentClass: string;
  @Input() labelTooltip?: string;
  @Input() disabled = false;

  isFieldInvalid(): boolean {
    return FormHelper.isControlInvalid(this.control);
  }
}
